import { createSlice } from "@reduxjs/toolkit";

type InitialStateType = { mode: string };

const currentMode = () => {
  //check for mode in localStorage if no mode set default mode to light in localStorage
  const mode = localStorage.getItem("mode");
  if (mode) {
    return mode;
  }
  localStorage.setItem("mode", "light");
  return "light";
};

const initialState: InitialStateType = { mode: currentMode() };

export const themeSlicer = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleThemeMode: (state: any) => {
      state.mode = state.mode === "light" ? "dark" : "light";
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { toggleThemeMode } = themeSlicer.actions;

export default themeSlicer.reducer;
